/**  Returns current date time in Swedish timezone in YYYY-MM-DD HH:mm*/
export const getSwedishDateTimeToday = (): string => {
  return new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' }).slice(0, 16);
};
